<template>
  <div>
    <Navbar />
    <div class="columns">
      <SideBar class="menu-sidebar"/>
      <div class="qi-content">
        <header>
          <h1>Filiais de Oferta</h1>
        </header>
        <vs-row>
          <NewSale />
        </vs-row>
        <vs-row>
          <SelectedCourseBox></SelectedCourseBox>
          <vs-col>
            <vs-row v-if="offers">
              <vs-col
                v-for="(offersInBranch, branch) in offers"
                :key="branch"
              >
                <vs-card style="box-shadow: 0px 0px 2px 1px #888888;">
                  <vs-row vs-align="center">
                    <vs-col vs-w="12">
                      <vs-row>
                        <h3>
                          {{ branch }}
                        </h3>
                      </vs-row>
                    </vs-col>
                    <vs-col vs-w="12">
                      <vs-row>
                        <vs-col
                          style="padding: 0;"
                          v-for="offerData in offersInBranch"
                          :key="offerData.CODTURNO"
                          :vs-w="offerData.MODALIDADE === 'D' ? 12 : 3"
                          vs-xs="12"
                        >
                          <vs-button
                            :style="offerData.MODALIDADE === 'D' ? 'width:50%;margin: 0 25%; 0 25%;' : 'width:95%;margin: 0.85% 2.5%; 0 2.5%;'"
                            @click="selectOffer(offerData)"
                          >
                            {{ formatShift(offerData) }}
                          </vs-button>
                        </vs-col>
                      </vs-row>
                    </vs-col>
                  </vs-row>
                </vs-card>
              </vs-col>
            </vs-row>
          </vs-col>
        </vs-row>
      </div>
    </div>
  </div>
</template>

<script>
import SelectedCourseBox from "../components/SelectedCourseBox.vue";
import CoursesService from "../services/courses";
import { bus } from "../main";
import {
  getStepsInformation,
  notifyError,
  updateStepsInformation,
} from "../helpers";
import { sortListByAttribute, updateDiscussion } from "../helpers";

export default {
  name: "Branches",
  components: {
    SelectedCourseBox,
  },
  data: () => ({
    offers: null,
    selectedCourse: null,
    error: false,
    offerSelected: null,
    electivesOptions: [],
  }),
  created() {
    const stepsData = getStepsInformation();
    if (stepsData.course) this.selectedCourse = stepsData.course;
  },
  mounted() {
    this.$vs.loading({
      color: "danger",
    });
    bus.$emit("updateSteps", 1);
    new CoursesService()
      .getOffers(
        this.selectedCourse.CODCURSO,
        this.selectedCourse.IDCLASSIFICACAO
      )
      .then(({ data }) => {
        if (!Array.isArray(data)) {
          this.selectOffer(data);
          return;
        }
        this.offers = sortListByAttribute(data, "FILIALCAMPUS");
        console.log(this.offers);
      })
      .catch(({ response }) => {
        if (response && response.data) {
          this.error = response.data.error;
        }
      })
      .finally(() => {
        this.$vs.loading.close();
      });
  },
  methods: {
    async selectOffer(offer) {
      this.$vs.loading({
        color: "danger",
      });
      const hasElectives = await this.hasElectives(offer);
      updateDiscussion(
        `Selecionou Oferta: ${offer.CIDADE} - ${offer.FILIALCAMPUS} - ${offer.TURNO}`,
        {
          offer,
          electives: null,
          classData: null,
          introductory: null,
        }
      ).finally(() => {
        if (offer.USAELETIVA == 0) {
          // Curso não tem eletiva -> vai direto para as turmas
          this.$router.push("/classes");
        } else {

          // Número mínimo é 1 ou mais e nao tem turma -> exibe erro na tela
          if (offer.NUMELETIVAS >= 1 && !hasElectives) {
            notifyError(
              this,
              "Oferta de Eletiva não encontrada - Favor comunicar o Planejamento Acadêmico"
            );
          }

          // Número mínimo é 0 e não tem turma -> vai direto para turmas
          else if (!hasElectives && offer.NUMELETIVAS == 0) {
              this.$router.push("/classes");
          }

          // Número mínimo é 1 e tem apenas 1 turma -> vai direto para turmas com a eletiva disponível
          else if (
              offer.NUMELETIVAS == 1 &&
              this.electivesOptions.length == 1
          ) {
              let electives = [];
              electives.push(this.electivesOptions[0]);
              updateStepsInformation({ electives });
              this.$router.push("/classes");
          }

          // Número mínimo é 0 ou mais e tem turma -> vai para tela de eletiva
          else this.$router.push("/electives");
        }
        this.$vs.loading.close();
      });
    },

    async hasElectives(offer) {
      let result = false;
      await new CoursesService()
        .getElectives(
          this.selectedCourse.CODCURSO,
          this.selectedCourse.IDCLASSIFICACAO,
          offer.IDHABILITACAOFILIAL,
          offer.CODCAMPUS
        )
        .then(({ data }) => {
          let electivesOptions =  Array.isArray(data) ? data : [data];
          electivesOptions = electivesOptions.filter(i => !!i)

          this.electivesOptions = electivesOptions;
          updateStepsInformation({ electivesOptions })
          if (electivesOptions.length > 0) {
            result = true;
          }
        })
        .catch(({ response }) => {
          if (response.status == 404) result = false;
        });
      return result;
    },

    formatShift({ TURNO: shift, MODALIDADE: type }) {
      if (type === "D") {
        return "A DISTÂNCIA";
      }
      return shift.trim().split(" ")[0];
    },
  },
};
</script>

